import { render, staticRenderFns } from "./AnswerMultipleChoice.vue?vue&type=template&id=f3bd240e&scoped=true&"
import script from "./AnswerMultipleChoice.vue?vue&type=script&lang=js&"
export * from "./AnswerMultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./AnswerMultipleChoice.vue?vue&type=style&index=0&id=f3bd240e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bd240e",
  null
  
)

export default component.exports